import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceResponse } from '@src/suite/common/data-models/service/service-response';

import { NomWebServicesJson } from './nom-web-services-json';

export type StoryLock = {
    IP: string;
    MacAddress: string[];
    Successful: boolean;
    UserId: string;
    Workstation: string;
    Expires: string;
};

@Injectable({ providedIn: 'root' })
export class StoryService {
    constructor(public nomWebServicesJson: NomWebServicesJson) {}

    public async lockStory(database: string, path: string, guid: string): Promise<ServiceResponse<StoryLock>> {
        let response: HttpResponse<StoryLock> = null;
        try {
            response = await this.nomWebServicesJson.put(
                '/api/Lock',
                {
                    database,
                    path,
                    guid,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                    }),
                    responseType: 'json',
                    observe: 'response',
                }
            );
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to lock story',
                detailMessage: `Unable to lock story. \n\rStackTrace: NomWebServicesJson.getBasicContent(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StoryLock>(false, `Unable to lock story ${error.toString()}`);
        }
        return new ServiceResponse<StoryLock>(true, response.body);
    }

    public async releaseStoryLock(database: string, path: string, guid: string): Promise<ServiceResponse<boolean>> {
        let response: HttpResponse<boolean> = null;
        try {
            response = await this.nomWebServicesJson.delete<boolean>('/api/Lock', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                body: JSON.stringify({
                    database,
                    path,
                    guid,
                }),
                responseType: 'json',
                observe: 'response',
            });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to lock story',
                detailMessage: `Unable to lock story. \n\rStackTrace: NomWebServicesJson.getBasicContent(); \n\rError: ${error}`,
            });
            return new ServiceResponse<boolean>(false, `Unable to release lock story ${error.toString()}`);
        }
        return new ServiceResponse<boolean>(true, response.body);
    }
}
